import { Toast } from '@common/overlay-manager';

import { issueUserAccountShopCouponList } from '../graphql/issue-user-account-shop-coupon-list.2';
import { IssueUserAccountShopCouponListInput } from '../graphql/issue-user-account-shop-coupon-list_types.2';
import { receiveMembershipBenefit } from '../graphql/receive-membership-benefit.2';

interface DownloadGeneralCouponProps {
  shop_id: string;
  product_id: string;
  policy_id: string;
}

export const downloadGeneralCoupon = async ({ shop_id, product_id, policy_id }: DownloadGeneralCouponProps) => {
  const input: IssueUserAccountShopCouponListInput = {
    shop_id_list: [shop_id],
    product_id_list: [product_id],
    user_account_coupon_policy_id_list: [policy_id],
    only_issuable: false,
  };

  try {
    const { data } = await issueUserAccountShopCouponList({ input }, { show_alert: false });
    if (data) {
      Toast.show('쿠폰을 받았어요');
    }
  } catch (e: any) {
    switch (e.code) {
      case 'exhausted_coupon':
        Toast.show('쿠폰이 소진되었어요');
        break;
      case 'expired_coupon':
        Toast.show('쿠폰 발급 기간이 지났어요');
        break;
      case 'invalid_coupon_policy_id':
        Toast.show('올바르지 않은 쿠폰이에요');
        break;
      case 'already_issued_coupon':
        Toast.show('이미 발급 받은 쿠폰이에요');
        break;
      case 'stopped_coupon_policy':
        Toast.show('쿠폰 발급이 종료되었습니다');
        break;
      case 'not_satisfied_issue_coupon_condition':
        Toast.show('발급대상이 아니에요');
        break;
      case 'throttle_max_request_exceeded':
        Toast.show('동시 요청이 많아 처리하지 못했어요');
        break;
      default:
        Toast.show('다시 시도해 주세요');
        break;
    }
  }
};

export const downloadMembershipCoupon = async () => {
  try {
    const { data } = await receiveMembershipBenefit(null, { show_alert: false });
    if (data) {
      Toast.show('쿠폰을 받았어요');
    }
  } catch (e: any) {
    switch (e?.extensions?.code) {
      case 'already_receive_membership_benefit':
        Toast.show('이미 발급 받은 쿠폰이에요');
        break;
      case 'not_possible_issue_coupon_pack':
        Toast.show('쿠폰 다운로드에 실패했어요');
        break;
      default:
        Toast.show('다시 시도해 주세요');
        break;
    }
  }
};
